<template>
  <div class="c-pageSize">
    Vis
    <a
      v-for="option in options"
      :key="option"
      @click="handleClick(option)"
      class="c-pageSize__option"
      :class="{ 'c-pageSize__option--active': activeOption == option }"
    >
      {{ option }}
    </a>
    rækker
  </div>
</template>

<script>
export default {
  name: "c-pageSize",
  props: ["options", "activeOption", "handleClick"]
};
</script>

<style lang="scss">
.c-pageSize {
  $root: &;

  @include setStyles("14", $s-typography-sizes);
  margin: toRem(15px 0 0);
  display: flex;
  justify-content: flex-end;

  &__option {
    @include setStyles("14", $s-typography-sizes);
    color: $s-cp-sup-blue;
    padding: toRem(0 4px 0 5px);
    cursor: pointer;

    & + #{$root}__option {
      border-left: 1px solid $s-cp-sup-blue;
    }

    &:hover {
      text-decoration: underline;
    }

    &--active {
      cursor: default;
      color: $s-cp-neutral-400;
      pointer-events: none;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
